import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import ConfirmationDeleteModal from '../confirmationDeleteModal/ConfirmationDeleteModal';
import { DataGridConfigContext } from '../../context/DataGridConfigContext';
import { DataGridContext } from '../../context/DataGridContext';

const GridConfirmationDeleteModal = () => {
  const { t } = useTranslation();
  const { translationKey } = useContext(DataGridConfigContext);
  const { objectIdBeingDeleted, setObjectIdBeingDeleted, confirmDeleteObject } =
    useContext(DataGridContext);

  const closeDeleteDialog = () => {
    setObjectIdBeingDeleted(null);
  };

  const confirmDelete = () => {
    if (objectIdBeingDeleted) {
      confirmDeleteObject(objectIdBeingDeleted);
    }
    closeDeleteDialog();
  };

  return (
    <ConfirmationDeleteModal
      open={objectIdBeingDeleted !== null}
      onClose={closeDeleteDialog}
      onConfirm={confirmDelete}
      title={t(`screens.${translationKey}.modal.confirmDeletionTitle`)}
      message={t(`screens.${translationKey}.modal.confirmDeletionMessage`)}
      confirmButtonText={t('actions.delete')}
      cancelButtonText={t('actions.cancel')}
    />
  );
};

export default GridConfirmationDeleteModal;
